import React from 'react';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import WorkflowStageFilter from 'components/ReactTable/Filters/WorkflowStageFilter';
import DateRangeFilter from 'components/ReactTable/Filters/DateRangeFilter';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import GetOptions from 'components/HomePage/GridColumnDefinitions/GetOptions';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const statementFormsTabColumnDefs = () => [
  {
    Header: 'Date Uploaded',
    accessor: 'documentUploadDate',
    Cell: ({ row }) => row.original.documentUploadDateDisplay || '',
    Filter: DateRangeFilter,
    className: 'col-15p form-date-upload',
    disableSortBy: false
  },
  {
    Header: 'Original File Name',
    accessor: 'originalFileName',
    className: 'col-20p form-file-name',
  },
  {
    Header: 'Source Path',
    accessor: 'sourcePath',
    className: 'col-40p form-source-path',
  },
  {
    Header: 'Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter,
    className: 'col-15p form-type',
  },
  {
    Header: 'Validity',
    accessor: 'formValidity',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('formValidity'),
    className: 'col-15p form-validity',
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStageDescriptionAlias',
    Filter: props => <WorkflowStageFilter { ...props } showStpOnly />,
    className: 'col-20p form-workflow-state',
  },
  {
    Header: 'Beneficial Owner',
    accessor: 'boName',
    className: 'col-20p form-beneficial-owner',
  },
];

export default statementFormsTabColumnDefs;
